import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Form, InputGroup } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { getBanche } from '../services/api';
import { CONDIZIONI_PAGAMENTO, calcolaAcconto } from './preventivoUtils';

// Condizioni di pagamento, acconto, banca per il bonifico, note per il cliente e link di accettazione di un preventivo.
// `value` e' l'oggetto preventivo del form, `onChange(patch)` ne aggiorna i campi.
function PreventivoPagamentoFields({ value, onChange }) {
  const [banche, setBanche] = useState([]);

  useEffect(() => {
    getBanche(0, 200)
      .then(res => setBanche((res.data?.banche || []).filter(b => b.iban && b.attivo !== false)))
      .catch(err => console.error('Errore caricamento banche:', err));
  }, []);

  const condizioni = value.condizioni_pagamento || [];
  const conAcconto = condizioni.includes('ACCONTO');
  const conBonifico = condizioni.includes('BONIFICO');
  const acconto = conAcconto ? calcolaAcconto(value.totale || 0, value.acconto_percentuale, value.acconto_importo) : null;

  return (
    <Card className="mb-4">
      <Card.Header>Condizioni di pagamento e invio</Card.Header>
      <Card.Body>
        <Row className="mb-3">
          <Form.Group as={Col} md={6} controlId="formCondizioniPagamento">
            <Form.Label>Condizioni di pagamento (anche più di una)</Form.Label>
            <Typeahead
              id="condizioni-pagamento-typeahead"
              multiple
              labelKey="label"
              options={CONDIZIONI_PAGAMENTO}
              selected={CONDIZIONI_PAGAMENTO.filter(c => condizioni.includes(c.id))}
              onChange={sel => onChange({ condizioni_pagamento: sel.map(s => s.id) })}
              placeholder="Scegli una o più condizioni..."
              emptyLabel="Nessuna altra condizione"
            />
          </Form.Group>
          {conBonifico && (
            <Form.Group as={Col} md={6} controlId="formBancaPreventivo">
              <Form.Label>Banca per il bonifico</Form.Label>
              <Form.Select value={value.banca_id || ''} onChange={e => onChange({ banca_id: e.target.value })}>
                <option value="">— scegli la banca —</option>
                {banche.map(b => (
                  <option key={b.id} value={b.id}>{b.denominazione} · {b.iban}</option>
                ))}
              </Form.Select>
              <Form.Text className="text-muted">L'IBAN compare nel PDF.</Form.Text>
            </Form.Group>
          )}
        </Row>

        {conAcconto && (
          <Row className="mb-3 align-items-end">
            <Form.Group as={Col} md={3} controlId="formAccontoPercentuale">
              <Form.Label>Acconto in percentuale</Form.Label>
              <InputGroup>
                <Form.Control type="number" min="0" max="100" step="0.1" value={value.acconto_percentuale ?? ''}
                  onChange={e => onChange({ acconto_percentuale: e.target.value })} />
                <InputGroup.Text>%</InputGroup.Text>
              </InputGroup>
            </Form.Group>
            <Form.Group as={Col} md={3} controlId="formAccontoImporto">
              <Form.Label>oppure importo fisso</Form.Label>
              <InputGroup>
                <InputGroup.Text>€</InputGroup.Text>
                <Form.Control type="number" min="0" step="0.01" value={value.acconto_importo ?? ''}
                  onChange={e => onChange({ acconto_importo: e.target.value })} />
              </InputGroup>
            </Form.Group>
            <Col md={6} className="pb-2">
              {acconto !== null ? (
                <span>Acconto <strong>€ {acconto.toFixed(2)}</strong> · Saldo alla consegna <strong>€ {Math.max((value.totale || 0) - acconto, 0).toFixed(2)}</strong></span>
              ) : (
                <span className="text-muted">Indica una percentuale o un importo (se compili entrambi vale l'importo).</span>
              )}
            </Col>
          </Row>
        )}

        <Row className="mb-3">
          <Form.Group as={Col} md={12} controlId="formNoteCliente">
            <Form.Label>Note per il cliente (compaiono nel PDF)</Form.Label>
            <Form.Control as="textarea" rows={2} value={value.note_cliente || ''}
              onChange={e => onChange({ note_cliente: e.target.value })}
              placeholder="Es. tempi di consegna, modalità di ritiro..." />
          </Form.Group>
        </Row>

        <Form.Check
          type="switch"
          id="includi-link-accettazione"
          label="Nella mail includi il link per accettare il preventivo online"
          checked={value.includi_link_accettazione !== false}
          onChange={e => onChange({ includi_link_accettazione: e.target.checked })}
        />
      </Card.Body>
    </Card>
  );
}

export default PreventivoPagamentoFields;
